import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { HelpCircle, ChevronDown } from 'lucide-react';
export const ClosingSection = () => {
  const faqs = [{
    q: '¿Y si estoy exagerando?',
    a: 'Entonces esto te devuelve calma y orden. Y eso ya vale la pena. Dejarás de buscar señales en cada movimiento.'
  }, {
    q: '¿Y si el pediatra me dice que espere?',
    a: 'La guía incluye un guión específico para responder a eso y pasos alternos (EI/Child Find) que puedes tomar sin referidos.'
  }, {
    q: '¿Y si me da miedo verlo por escrito?',
    a: 'Más miedo da quedarse congelado. Esto no etiqueta a tu hijo. Esto te mueve a la acción correcta.'
  }];
  return <section className="w-full bg-white py-20 px-4 pb-32" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        {/* FAQ */}
        <div className="mb-20" data-id="element-16">
          <h2 className="text-2xl font-serif font-bold text-[#1B2A4A] mb-8 text-center" data-id="element-17">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-6" data-id="element-18">
            {faqs.map((faq, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#FFF9F3] p-6 rounded-xl border border-[#1B2A4A]/5" data-id="element-19">
                <h3 className="font-bold text-[#1B2A4A] mb-2 flex items-center" data-id="element-20">
                  <HelpCircle className="w-4 h-4 mr-2 text-[#2ABFBF]" data-id="element-21" />
                  {faq.q}
                </h3>
                <p className="text-[#2D3436]" data-id="element-22">{faq.a}</p>
              </motion.div>)}
          </div>
        </div>

        {/* Final CTA */}
        <div className="text-center space-y-6" data-id="element-23">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#1B2A4A]" data-id="element-24">
            Si tu intuición no se calla,
            <br data-id="element-25" /> no lo negocies.
          </h2>
          <p className="text-lg text-[#2D3436] max-w-xl mx-auto" data-id="element-26">
            No esperes “a ver”. Descarga La Ruta Clara y en menos de una hora
            vas a tener claridad, un tracker, y un plan de 14 días.
          </p>

          <div className="pt-4" data-id="element-27">
            <Button size="lg" className="w-full md:w-auto px-12 text-lg animate-pulse-slow" data-id="element-28">
              Quiero mi Ruta Clara
            </Button>
            <p className="mt-4 text-sm text-[#2D3436]/60" data-id="element-29">
              Compra segura · Garantía de satisfacción
            </p>
          </div>
        </div>
      </div>
    </section>;
};